import { observable, action, computed, toJS } from "mobx";
import { setCookie } from "../api/cookies";

export const COOKIE_NAME = "CookieConsent";

class UiStore {
  @observable context = null;
  defaultContext = "depi";
  @observable functionalCookiesAccepted = null;
  @observable marketingCookiesAccepted = null;
  @observable adCookiesAccepted = null;
  @observable gaCookiesAccepted = null;
  @observable fpCookiesAccepted = null;
  @observable obCookiesAccepted = null;
  @observable showCookiePreferences = false;

  @action.bound
  setContext(context) {
    if (context) this.context = context;
  }

  @action.bound
  acceptAllCookies() {
    this.functionalCookiesAccepted = true;
    this.marketingCookiesAccepted = true;
    this.adCookiesAccepted = true;
    this.gaCookiesAccepted = true;
    this.fpCookiesAccepted = true;
    this.obCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-functional`, true);
    setCookie(`${this.context}${COOKIE_NAME}-marketing`, true);
    setCookie(`${this.context}${COOKIE_NAME}-ga`, true);
    setCookie(`${this.context}${COOKIE_NAME}-fp`, true);
    setCookie(`${this.context}${COOKIE_NAME}-ad`, true);
    setCookie(`${this.context}${COOKIE_NAME}-ob`, true);
  }

  @action.bound
  declineAllCookies() {
    this.functionalCookiesAccepted = false;
    this.marketingCookiesAccepted = false;
    this.adCookiesAccepted = false;
    this.gaCookiesAccepted = false;
    this.fpCookiesAccepted = false;
    this.obCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-functional`, false);
    setCookie(`${this.context}${COOKIE_NAME}-marketing`, false);
    setCookie(`${this.context}${COOKIE_NAME}-ga`, false);
    setCookie(`${this.context}${COOKIE_NAME}-fp`, false);
    setCookie(`${this.context}${COOKIE_NAME}-ad`, false);
    setCookie(`${this.context}${COOKIE_NAME}-ob`, false);
  }

  setFromCookies = (cookies) => {
    const functionalCookie =
      cookies[`${this.context}${COOKIE_NAME}-functional`];
    const marketingCookie = cookies[`${this.context}${COOKIE_NAME}-marketing`];
    const gaCookie = cookies[`${this.context}${COOKIE_NAME}-ga`];
    const fpCookie = cookies[`${this.context}${COOKIE_NAME}-fp`];
    const adCookie = cookies[`${this.context}${COOKIE_NAME}-ad`];
    const obCookie = cookies[`${this.context}${COOKIE_NAME}-ob`];
    if (functionalCookie) {
      this.functionalCookiesAccepted = functionalCookie === "true";
    }
    if (marketingCookie) {
      this.marketingCookiesAccepted = marketingCookie === "true";
    }
    if (gaCookie) {
      this.gaCookiesAccepted = gaCookie === "true";
    }
    if (fpCookie) {
      this.fpCookiesAccepted = fpCookie === "true";
    }
    if (adCookie) {
      this.adCookiesAccepted = adCookie === "true";
    }
    if (obCookie) {
      this.obCookiesAccepted = obCookie === "true";
    }
  };

  @action.bound
  acceptFunctionalCookies() {
    this.functionalCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-functional`, true);
  }

  @action.bound
  declineFunctionalCookies() {
    this.functionalCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-functional`, false);
  }

  @action.bound
  acceptMarketingCookies() {
    this.marketingCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-marketing`, true);
  }

  @action.bound
  declineMarketingCookies() {
    this.marketingCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-necessary`, true);
    setCookie(`${this.context}${COOKIE_NAME}-marketing`, false);
  }

  @action.bound
  acceptOutbrainCookie() {
    this.obCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-ob`, true);
  }

  @action.bound
  declineOutbrainCookie() {
    this.obCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-ob`, false);
  }

  @action.bound
  acceptGoogleAdsCookie() {
    this.adCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-ad`, true);
  }

  @action.bound
  declineGoogleAdsCookie() {
    this.adCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-ad`, false);
  }

  @action.bound
  acceptGoogleAnalyticsCookie() {
    this.gaCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-ga`, true);
  }

  @action.bound
  declineGoogleAnalyticsCookie() {
    this.gaCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-ga`, false);
  }

  @action.bound
  acceptFacebookPixelCookie() {
    this.fpCookiesAccepted = true;
    setCookie(`${this.context}${COOKIE_NAME}-fp`, true);
  }

  @action.bound
  declineFacebookPixelCookie() {
    this.fpCookiesAccepted = false;
    setCookie(`${this.context}${COOKIE_NAME}-fp`, false);
  }

  @action.bound
  setShowCookiePreferences(state) {
    this.showCookiePreferences = state;
  }

  setFromQueryParameters = ({}) => {};

  connectStores = ({ dataStore }) => {
    this.dataStore = dataStore;
  };

  getSnapshot = () => {
    const { dataStore, ...rest } = this;
    return toJS(rest);
  };

  hydrate = (snapshot) => {
    Object.keys(snapshot).forEach((key) => {
      this[key] = snapshot[key];
    });
  };
}

export default UiStore;
